export const state = {
  notification: {
    title: '',
    message: '',
    startDateTime: '',
    endDateTime: '',
    allFlag: false,
    companyList: [
      {
        corporationName: '',
        companyId: '',
        companyName: ''
      }
    ]
  },
  notifications: [],
  total: 0,
  addData: {},
  updateData: {},
  selectedTenantList: [],
  isCancel: false
}
export const mutations = {
  setNotifications(state, response) {
    if (response.data['data'] == null) {
      response.data['data'] = [{}]
      state.total = 0
    }
    state.notifications = response.data['data']
    state.total = response.data['header']['total']
  },
  setNotificationsDetail(state, response) {
    if (response.data['data'] == null) {
      response.data['data'] = [{}]
    }
    state.notification = response.data['data']
    let list = response.data['data']['companyList']
    let payload = []
    list.forEach(company => {
      payload.push({
        companyId: company.companyId,
        companyName: company.companyName,
        corporationName: company.corporationName,
        checked: true
      })
    })
    state.selectedTenantList = list
  },
  inputUpdate(state, payload) {
    state.updateData[payload.name] = payload.value
  },
  inputAddUpdate(state, payload) {
    state.addData[payload.name] = payload.value
  },
  updateSelectedTenantList(state, payload) {
    for (var i = 0; i < payload.length; i++) {
      if (
        payload[i].checked &&
        !state.selectedTenantList.some(
          tenant => tenant.companyId === payload[i].companyId
        )
      ) {
        state.selectedTenantList.push(payload[i])
      } else if (
        !payload[i].checked &&
        state.selectedTenantList.some(
          tenant => tenant.companyId === payload[i].companyId
        )
      ) {
        const deleteIndex = state.selectedTenantList.findIndex(
          tenant => tenant.companyId === payload[i].companyId
        )
        state.selectedTenantList = state.selectedTenantList.toSpliced(
          deleteIndex,
          1
        )
      }
    }
  },
  clearUpdateData(state) {
    state.updateData = {}
  },
  clearAddData(state) {
    state.addData = {}
  },
  clearSelectedTenantList(state) {
    state.selectedTenantList = []
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/systemAdminModules/notificationsModules/notificationsMutation.js